import React, { FC } from 'react'
import { Marker } from '../types/map'
import { SpecialistProfile } from '../types/specialist'
import { PracticeProfile } from '../types/practice'

export const profilesToMarkers = (
  profiles: Array<SpecialistProfile | PracticeProfile>,
  InfoWindowComponent: FC<SpecialistProfile | PracticeProfile>,
  distance?: number
): Array<Marker> => {
  if (!profiles) {
    return []
  }
  return profiles?.reduce<Array<Marker>>((prev, profile) => {
    if ('address' in profile && profile.address.geolocation) {
      return [
        ...prev,
        {
          position: profile.address.geolocation,
          content: <InfoWindowComponent {...profile} />
        }
      ]
    }
    if ('practices' in profile) {
      const filteredPractices = profile.practices.filter((p) => p.distance <= (distance || 25))
      return [
        ...prev,
        ...filteredPractices.map<Marker>((practice) => ({
          position: practice.address.geolocation,
          content: <InfoWindowComponent {...profile} />
        }))
      ]
    }
    return prev
  }, [])
}
